const GuidelineSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M2.85742 3.71484V12.2822" stroke="#333333" strokeLinecap="round" />
      <path d="M13.1426 6.28516V12.2851" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.57227 2H8.85797" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.57227 14H11.4294" stroke="#333333" strokeLinecap="round" />
      <path
        d="M13.142 12.2852C13.1467 13.1413 12.2849 13.9994 11.4277 13.9994"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.85798 12.2852C2.85798 13.1423 3.71512 13.9994 4.57227 13.9994"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.85798 3.71484C2.85798 2.85895 3.71512 2.02089 4.57227 2.0018"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13.1384 6.28955L8.85742 2" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M8.85798 4.57227C8.86062 5.42474 9.71858 6.28655 10.5723 6.28655"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.85742 4.57142V2" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.5723 6.28516H13.1437" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9 3H9.5L12 5.5V6H9V3Z" fill="#333333" />
    </svg>
  );
};

export default GuidelineSvg;
